import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';

const Hero = () => {
  const handleViewWorkClick = () => {
    const element = document.getElementById('showcase');
    if (!element) return;

    const navbarHeight = 128;
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - navbarHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };

  return (
    <section id="home" className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden bg-white dark:bg-gray-900 transition-colors duration-300 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 text-gray-900 dark:text-white transition-colors duration-300 leading-tight">
            AI Systems Builder
            <span className="text-teal-400 block sm:inline"> and Full-Stack Engineer</span>
          </h1>
          <p className="text-lg sm:text-xl mb-6 sm:mb-8 text-gray-700 dark:text-gray-300 transition-colors duration-300 max-w-2xl mx-auto">
            I&apos;m Ahmaad Idrees, a full-stack engineer, AI systems builder, and K-8 STEM teacher focused on practical, reliable software for real users. My work spans applied AI, product development, evaluation, and education technology.
          </p>
          <button
            onClick={handleViewWorkClick}
            className="inline-flex items-center bg-teal-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold hover:bg-teal-400 transition duration-300 text-sm sm:text-base hover:shadow-md"
          >
            View Selected Work
            <ArrowRight className="ml-2" size={16} />
          </button>
        </div>
        <div className="mt-12 sm:mt-16 text-center">
          <ChevronDown size={24} className="mx-auto text-teal-400" />
          <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 transition-colors duration-300">Selected work and background</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
